/**
 * Configuração padrão de paginação para todas as listagens (antd Table e ProTable).
 * Padrão único do produto: "X-Y de Y itens" + seletor de registros por página
 * (10/20/50/100/500/1000), iniciando em 10.
 */
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100', '500', '1000'];

export const defaultTablePagination = {
    defaultPageSize: DEFAULT_PAGE_SIZE,
    // Objeto (SelectProps) habilita o seletor e desativa a digitação/busca nele
    showSizeChanger: { showSearch: false },
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showTotal: (total, range) =>
        `${range[0]}-${range[1]} de ${total} ${total === 1 ? 'item' : 'itens'}`,
};
